export default __webpack_public_path__ + "img/250MA_BF.7ef14873bfee2f873bc40a464a4d7ca4.jpg";